(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiftech-ip-footer-link"]) return;
  try {
    
function updateKiftechIpFooterNotice(root) {
  var scope = root && root.querySelectorAll ? root : document;
  var selector =
    '.footer__copyright .copyright__content a[href="/pages/trademark-notice"], ' +
    '.footer__copyright .copyright__content a[href="/pages/intellectual-property-notice"]';
  var links = scope.querySelectorAll(selector);

  if (!links.length && scope !== document) {
    links = document.querySelectorAll(selector);
  }

  links.forEach(function (link) {
    var container = link.closest('small.copyright__content');
    if (!container || container.hasAttribute('data-kiftech-ip-notice')) return;

    var text = (container.textContent || '').replace(/\s+/g, ' ').trim();
    if (!/TRADEMARK NOTICE|INTELLECTUAL PROPERTY NOTICE/i.test(text)) return;

    container.innerHTML =
      '(Pty) Ltd. All Rights Reserved. ' +
      '<a href="/pages/intellectual-property-notice" aria-label="Read the KifTech Intellectual Property Notice">INTELLECTUAL PROPERTY NOTICE</a>: ' +
      'Third-party brand names, logos and trade marks belong to their respective owners. ' +
      'KifTech is an independent retailer; references identify products or compatibility and do not imply affiliation, sponsorship or endorsement.';
    container.setAttribute('data-kiftech-ip-notice', 'true');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    updateKiftechIpFooterNotice(document);
  });
} else {
  updateKiftechIpFooterNotice(document);
}

document.addEventListener('shopify:section:load', function (event) {
  updateKiftechIpFooterNotice(event.target);
});

window.addEventListener('pageshow', function () {
  updateKiftechIpFooterNotice(document);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kt-header-search"]) return;
  try {
    
(() => {
  if (customElements.get('kt-header-search-controller')) return;
  class KtHeaderSearchController extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.row = this.querySelector('.kt-header-search-row');
      if (!this.row) return;
      this.input = this.row.querySelector('#KtHeaderSearchInput');
      this.media = window.matchMedia('(max-width: 989px)');
      this.abort = new AbortController();
      this.open = false;
      const options = { signal: this.abort.signal };
      this.onMediaChange = () => this.place();
      this.media.addEventListener('change', this.onMediaChange);
      document.addEventListener('DOMContentLoaded', () => this.mount(), options);
      document.addEventListener('shopify:section:load', () => this.mount(), options);
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(this)) this.disconnect();
        else if (this.header && event.target.contains(this.header)) this.restore();
      }, options);
      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.contains(this) && this.media.matches && this.toggle) this.setOpen(true);
      }, options);
      this.row.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.media.matches && this.toggle) {
          event.preventDefault();
          this.setOpen(false);
          this.toggle.focus({ preventScroll: true });
        }
      }, options);
      this.mount();
    }
    disconnectedCallback() {
      this.disconnect();
    }
    disconnect() {
      if (!this.abort) return;
      this.abort.abort();
      this.media.removeEventListener('change', this.onMediaChange);
      this.restore();
      this.abort = null;
    }
    restore() {
      if (!this.row) return;
      this.toggleAbort?.abort();
      this.toggleAbort = null;
      if (this.toggle) {
        this.toggle.removeAttribute('role');
        this.toggle.removeAttribute('aria-controls');
        this.toggle.removeAttribute('aria-expanded');
        this.toggle.setAttribute('aria-label', this.fallbackLabel);
      }
      this.toggle = null;
      this.header?.classList.remove('kt-header-search-enabled', 'kt-mobile-search-ready');
      this.row.classList.remove('kt-header-search-row--inline');
      delete this.row.dataset.ktCollapsed;
      if (this.row.parentElement !== this) this.appendChild(this.row);
      this.header = null;
      this.wrapper = null;
    }
    mount() {
      if (!this.isConnected || !this.abort || !this.input) return;
      const header = document.querySelector('.section-header .header');
      const wrapper = document.querySelector('.section-header .header-wrapper');
      const toggle = header?.querySelector('.kt-mobile-search-toggle');
      if (!header || !wrapper || !toggle) return;
      if (header !== this.header || !this.toggle?.isConnected) {
        this.restore();
        this.header = header;
        this.wrapper = wrapper;
        this.toggle = toggle;
        this.fallbackLabel = toggle.getAttribute('aria-label');
        this.toggle.setAttribute('role', 'button');
        this.toggle.setAttribute('aria-controls', this.row.id);
        this.toggleAbort = new AbortController();
        this.toggle.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.setOpen(!this.open);
          (this.open ? this.input : this.toggle).focus({ preventScroll: true });
        }, { signal: this.toggleAbort.signal });
        this.toggle.addEventListener('keydown', (event) => {
          if (event.key === ' ') {
            event.preventDefault();
            this.toggle.click();
          }
        }, { signal: this.toggleAbort.signal });
      }
      this.place();
    }
    place() {
      if (!this.header?.isConnected || !this.toggle?.isConnected) return;
      const active = document.activeElement;
      const focusedInRow = this.row.contains(active);
      const focusedToggle = active === this.toggle;
      if (this.media.matches) {
        this.header.classList.remove('kt-header-search-enabled');
        this.row.classList.remove('kt-header-search-row--inline');
        if (this.row.parentElement !== this.wrapper) this.wrapper.appendChild(this.row);
        this.setOpen(this.open || focusedInRow);
      } else {
        this.header.classList.add('kt-header-search-enabled');
        this.row.classList.add('kt-header-search-row--inline');
        if (this.row.parentElement !== this.header) {
          this.header.insertBefore(this.row, this.header.querySelector('.header__icons'));
        }
        this.setOpen(false);
      }
      if (focusedInRow) active.focus({ preventScroll: true });
      else if (focusedToggle && !this.media.matches) this.input.focus({ preventScroll: true });
    }
    setOpen(open) {
      this.open = this.media.matches && open;
      this.row.dataset.ktCollapsed = String(this.media.matches && !this.open);
      this.toggle.setAttribute('aria-expanded', String(this.open));
      this.toggle.setAttribute('aria-label', this.open ? this.dataset.closeLabel : this.dataset.searchLabel);
    }
  }
  customElements.define('kt-header-search-controller', KtHeaderSearchController);
})();

  } catch(e) { console.error(e); }
})();
})();
